import logo from "../../assets/logo-cropped.png";
import "./Footer.scss";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
    const links = ["हमारे बारे में",
        "न्यूज लेटर",
        "विज्ञापन",
        "आर्काइव",
        "एप्स",
        "करियर",
        "चैनल",
        "ईपीजी सर्विस",
        "डिस्क्लेमर",
        "फीडबैक",
        "इन्वेस्टर्स",
        "निवारण",
        "गोपनीयता नीति",
        "संपर्क करें"];

    return <>
        <div className="footer">
            <div className="footer-main">
                <div className="footer-logo-socials">
                    <div className="footer-logo">
                        <img src={logo} alt="India Express Logo" width={65} height={55}/>
                    </div>
                    <div className="footer-socials">
                        <a href="#"><FaFacebookF className="social-icon facebook" /></a>
                        <a href="#"><FaTwitter className="social-icon twitter" /></a>
                        <a href="#"><FaInstagram className="social-icon instagram" /></a>
                        <a href="#"><FaYoutube className="social-icon youtube" /></a>
                    </div>
                </div>
                <div className="footer-links">
                    {links.map((link, index) => (
                        <span key={index} className="footer-link">
                            <a href="#">{link}</a>
                        </span>
                    ))}
                </div>
            </div>
            <div className="footer-copyright">
                <p>© 2023 India Express. All rights reserved.</p>
            </div>
        </div>
    </>
}

export default Footer;